import React from "react";
import { useParams } from "react-router";

/**
 * Renders a route component with the URL params as a plain `params` prop.
 *
 * Function components should call useParams() directly. This exists for the
 * pages wrapped in connect(), whose mapStateToProps reads params off ownProps
 * and therefore needs them passed in from above.
 */
export const withParams = (Component) => {
  const RouteElement = (props) => <Component {...props} params={useParams()} />;
  RouteElement.displayName = `withParams(${Component.displayName || Component.name || "Route"})`;
  return <RouteElement />;
};
